import { render, staticRenderFns } from "./PostQuickView.vue?vue&type=template&id=32d22e58&"
import script from "./PostQuickView.vue?vue&type=script&lang=js&"
export * from "./PostQuickView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports